import { InvalidInstructorContractedBlocks } from "@models/ISchema";

// CHS-2756 / EDH-015 (backend code VALIDATE_INSTRUCTOR_CONTRACTED_BLOCKS,
// draft PR darwined#5406). Kept as a named constant (rather than a literal in
// every switch/case) so the single source of truth stays here if it ever changes.
export const INSTRUCTOR_CONTRACTED_BLOCKS_TYPENAME: InvalidInstructorContractedBlocks["__typename"] =
  "InvalidInstructorContractedBlocks";

export interface InstructorContractedBlocksPayload {
  instructorCode: string;
  contracted: number | string;
  assigned: number | string;
  difference: number | string;
}

export const mapInstructorContractedBlocksPayload = (
  incidence: Partial<InvalidInstructorContractedBlocks>,
): InstructorContractedBlocksPayload => ({
  instructorCode: incidence?.instructor?.code ?? "",
  contracted: incidence?.contracted ?? "-",
  assigned: incidence?.assigned ?? "-",
  difference: incidence?.difference ?? "-",
});
